Jelly.Actions.Add_Guest = function(Parameters) {	
	// Get elements
	var $Add_Guest_Table_Wrapper = $(
		"#" + Parameters.Namespace.Action + "_Add_Guest_Table_Wrapper"
	);
	var $Add_Guest_Table = $Add_Guest_Table_Wrapper.find('table');

	// Get count
	var Guest_Count = $Add_Guest_Table.find('tr').length;

	/* Add table rows */
	var $Add_Guest_Row = $('<tr/>');
	$Add_Guest_Row.append($('<td/>').html(Parameters.Guest.Name));
	$Add_Guest_Row.append($('<td/>').html(Parameters.Guest.Email));
	$Add_Guest_Row.append($('<td/>').html(Parameters.Guest.Quantity));
	$Add_Guest_Table.append($Add_Guest_Row);

	/* Show table if hidden */
	$Add_Guest_Table_Wrapper.show();

	/* Add hidden values */
	Jelly.Actions.Add_Hidden_Value({
			Namespace: Parameters.Namespace.Action
		,	Input_Alias: "Add_Guest_Count"
		, Value: Guest_Count
	});
	Jelly.Actions.Add_Hidden_Value({
			Namespace: Parameters.Namespace.Action
		,	Input_Alias: "Add_Guest_" + Guest_Count + '_Name'
		, Value: Parameters.Guest.Name
	});
	Jelly.Actions.Add_Hidden_Value({
			Namespace: Parameters.Namespace.Action
		,	Input_Alias: "Add_Guest_" + Guest_Count + '_Email'
		, Value: Parameters.Guest.Email
	});
	Jelly.Actions.Add_Hidden_Value({
			Namespace: Parameters.Namespace.Action
		,	Input_Alias: "Add_Guest_" + Guest_Count + '_Quantity'
		, Value: Parameters.Guest.Quantity
	});
};

Jelly.Actions.Add_Guests = function (Parameters) {

	// Validate JSON
	if (!Parameters.Guests[0]) {
		throw "CSV did not translate into rows";
	}

	// Trim JSON 
	Parameters.Guests = Parameters.Guests.map(function(Guest){
		return Guest.map(function(Value){ 
			return Value.trim();
		});
	});

	// Determine columns

	// Try finding headers
	var Found_Headers = false;
	var Possible_Header = Parameters.Guests[0].map(function(Value) { return Value.trim().toLowerCase();});
	var Columns = {};
	Columns.Name = Possible_Header.indexOf("name");
	Columns.Email = ((Possible_Header.indexOf("email") > -1)? Possible_Header.indexOf("email") : Possible_Header.indexOf("email address"));
	Columns.Quantity = Possible_Header.indexOf("quantity");
	if (Columns.Name > -1 && Columns.Email > -1 && Columns.Quantity > -1) {
		Found_Headers = true;
	} else {
		Columns = {Name: 0, Email: 1, Quantity: 2};
	}

	// Find the first duplicate
	var Duplicate_Email = null;
	var Duplicate_Seen = new Set();
	var Found_Duplicate = Parameters.Guests.some(function(Guest) {
		Duplicate_Email = Guest[Columns.Email];
	  return Duplicate_Seen.size === Duplicate_Seen.add(Guest[Columns.Email]).size;
	});
	if (!Found_Duplicate)
		Duplicate_Email = null;		
	
	// Validate guest
	var Found_Error = false;
	$.each(Parameters.Guests, function (Row_Index, Row) { 
		if (!Found_Headers || Row_Index > 0) {
			
			var Validate_Error = false;
	
			// Validate guest in general
			Validate_Error = Jelly.Actions.Validate_Guest({
					Name: Row[Columns.Name]
				,	Email: Row[Columns.Email]
				,	Quantity: Row[Columns.Quantity]
				, Namespace: Parameters.Namespace
			});

			// Make sure this row has a unique email address (relative to the import)
			if (Duplicate_Email && Duplicate_Email == Row[Columns.Email]) { 
				Validate_Error = "This email address appears twice in this file.  Please make sure you only have one row per person.";
			}

			// Show error on validation failure
			if (Validate_Error) {
				Throw_Error = ' in row ' + Row_Index + ' - ' + Validate_Error;
				Throw_Error += "\n\n";
				var Match_Trailing_Comma = /(^,)|(,$)/g;
				Throw_Error += Row.toString().replace(Match_Trailing_Comma, "");

				if (!Found_Headers) {
					Throw_Error += "\n\n";
					Throw_Error += "We didn't see a header column with Name, Email, and Quantity, so we assumed the list was formatted in that order respectively.  If it's in another order, include a header row with Name, Email, and Quantity";
				}

				Throw_Error += "\n\n";
				Throw_Error += "We didn't import this file.  Please check these errors and try again.";
				throw Throw_Error;
			}
		}
	});

	// Add guests
	$.each(Parameters.Guests, function (Row_Index, Row) { 
		if (!Found_Headers || Row_Index > 0) {
			console.log(Columns);
			var Guest_Value = {
					Namespace: Parameters.Namespace
				,	Guest: {
							Name: Row[Columns.Name]
						,	Email: Row[Columns.Email]
						,	Quantity: Row[Columns.Quantity]
					}
			};
			console.log(Guest_Value);
			Jelly.Actions.Add_Guest(Guest_Value);
			console.log('afterwards');
		}
	});
	
}

Jelly.Actions.Validate_Guest = function(Parameters) { 

	// Validate input
	var Email_Validator = new RegExp('^\[^@\\s\]+@\[^@\\s\]+\\.\[^@\\s\]+$', 'i');
	if (!Parameters.Name) { 
		return'Please enter a name';
	}
	if (!Parameters.Quantity) { 
		return'Please enter a quantity';
	}
	if (Parameters.Email && !Email_Validator.test(Parameters.Email)) {
		return 'Please enter a valid email address';
	}

	// Make sure that guest doesn't already exist in table
	if (Parameters.Email) { 
		var Email_Is_Unique = true;
		var $Add_Guest_Table_Wrapper = $(
			"#" + Parameters.Namespace.Action + "_Add_Guest_Table_Wrapper"
		);
		$Add_Guest_Table_Wrapper.find('table tr').each(function(Row_Index, Row) {
			if (Parameters.Email == $(Row).find('td:eq(1)').html()) {
				return (Email_Is_Unique = false);
			}
		});
		if (!Email_Is_Unique)
			return "You've already entered this email address";
	}
};